import * as React from 'react'
import * as logger from '@owl-nest/logger'
import { PlausibleEvent, Track } from './types'
import { fakePush } from './safePush'

export function simulateTrack({ type, props, callback }: PlausibleEvent): void {
  logger.warn('[shadow:plausible] plausible tracking context was not initialized')
  fakePush(type, { props, callback })
}

export const trackingContext = React.createContext<Track>(simulateTrack)
